import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from "@headlessui/react";
import React, { useEffect } from "react";

export interface Props {
	open?: boolean;
	title?: string;
	overflow?: string;
	maxWidth?: string;
	onClose: () => void;
	children: React.ReactNode;
}

export default function ModalFrame(props: Props) {
	useEffect(() => {
		const keyDownHandler = (event: KeyboardEvent) => {
			if (event.key === "Escape") {
				event.preventDefault();
				props.onClose();
			}
		};

		if (!props.open) {
			document.removeEventListener("keydown", keyDownHandler);
			return;
		}

		document.addEventListener("keydown", keyDownHandler);

		return () => {
			document.removeEventListener("keydown", keyDownHandler);
		};
	}, [props.open]);

	return (
		<Dialog open={props.open} onClose={() => {}} className="relative z-10">
			<DialogBackdrop
				transition
				className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
			/>

			<div className="fixed inset-0 z-10 w-screen overflow-y-auto">
				<div className="flex min-h-full items-end justify-center p-2 text-center sm:items-center sm:p-0">
					<DialogPanel
						transition
						className={
							`relative rounded-lg bg-white px-4 pb-4 pt-2 text-left shadow-xl ${props.overflow ?? "overflow-hidden"} ` +
							`transform transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in ` +
							`sm:my-8 sm:w-full ${props.maxWidth ?? "sm:max-w-[650px]"} sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`
						}>
						<div className="text-left divide-y">
							{props.title && (
								<DialogTitle
									as="h3"
									className="text-base font-semibold text-gray-900 pb-1">
									{props.title}
								</DialogTitle>
							)}
							{props.children}
						</div>
					</DialogPanel>
				</div>
			</div>
		</Dialog>
	);
}
